import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IShopSchema } from "../../shared/types";
import { RootState } from "../store";

const initialState:IShopSchema = {
  cash_in_shop: 0,
  created_at: new Date(),
  gross_profit: 0,
  gross_revenue: 0,
  items_in_stock: 0,
  name: ""
}

const currentBusinessShop = createSlice({
  name: "currentBusinessShop",
  initialState,
  reducers: {
    setCurrentAdminShop: (state:IShopSchema, action:PayloadAction<IShopSchema>) => {
      state = action.payload;
    },
    clearCurrentAdminShop: (state:IShopSchema)=>{
      state = initialState
    }
  }
});

export const currentAdminShopActions = currentBusinessShop.actions;
export const selectCurrrentAdminShop = (state: RootState) => state.currentBusinessShop;

export default currentBusinessShop.reducer;
